import AdminEditButtons from "lib/components/common/admin-edit-buttons";
import FlexBox from "lib/components/common/flex-box";
import SimpleButton from "lib/components/common/simple-button";
import SimpleModal from "lib/components/common/simple-modal";
import PractitionerProfileCard from "lib/components/profile/practitioner-profile-card";
import { PRACTITIONER_STATUS } from "lib/constants/enums";
import { AppContext } from "lib/contexts/app-context";
import usePractitioner from "lib/hooks/usePractitioner";
import useTherapies from "lib/hooks/useTherapies";
import { isAdminUser, isSuperAdminUser } from "lib/utils/util";
import { useState, useEffect, useContext } from "react";
import { Button } from "react-bootstrap";

interface PractitionerInfoProps {
  practitionerInfo: PractitionerDetails;
  open: boolean;
  onClose: () => void;
  onApprove?: () => void;
  onReject?: () => void;
  onDisable?: (value: boolean) => void;
  onDelete?: () => void;
  isScrollable?: boolean;
}
const PractitionerInfo = ({
  practitionerInfo,
  open,
  onClose,
  onApprove,
  onReject,
  onDisable,
  onDelete,
  isScrollable = true,
}: PractitionerInfoProps) => {
  const { appState } = useContext(AppContext);
  const {
    getPractitionerTherapies,
    getPractitionerProfilePic,
    getPractitionerDocuments,
    getPractitionerSubscriptions,
    loading: practitionerLoading,
    error: practitionerError,
  } = usePractitioner();
  const { therapies, getTherapies, loading: therapiesLoading } = useTherapies();

  const [practitionerDetails, setPractitionerDetails] =
    useState<PractitionerDetails | null>(null);
  const [practitionerTherapies, setPractitionerTherapies] = useState<
    PractitionerTherapy[]
  >([]);
  const [practitionerSubscriptions, setPractitionerSubscriptions] = useState<
    PractitionerSubscriptionDetails[]
  >([]);
  const [profilePicUrl, setProfilePicUrl] = useState<string | null>(null);
  const [practitionerDocuments, setPractitionerDocuments] =
    useState<PractitionerDocuments>(null);

  useEffect(() => {
    // getPractitionerDetails(practitionerInfo?.id, (value) => {
    //   setPractitionerDetails(value);
    //   getPractitionerTherapies(value?.id, setPractitionerTherapies);
    //   getPractitionerProfilePic(value?.id, setProfilePicUrl);
    //   getPractitionerDocuments(value?.id, setPractitionerDocuments);
    // });
    if (practitionerInfo) {
      setPractitionerDetails(practitionerInfo);
      getPractitionerTherapies(practitionerInfo?.id, setPractitionerTherapies);
      getPractitionerProfilePic(practitionerInfo?.id, setProfilePicUrl);
      //getPractitionerDocuments(practitionerInfo, [], setPractitionerDocuments);
      getPractitionerSubscriptions(practitionerInfo?.id, (subscriptions) => {
        setPractitionerSubscriptions(subscriptions);
        getPractitionerDocuments(
          practitionerInfo,
          subscriptions,
          setPractitionerDocuments
        );
      });
      getTherapies();
    }
  }, [practitionerInfo]);

  /** Calculated vars */
  const isSuperAdmin = isSuperAdminUser(appState?.userRole);
  const isAdmin = isAdminUser(appState?.userRole);
  console.log(appState?.userRole);
  /** Calculated vars */

  const getFooter = () => {
    const isApprovedAndActive =
      practitionerInfo?.status === PRACTITIONER_STATUS.APPROVED &&
      practitionerInfo?.isActive;

    const canDisable = (isAdmin || isSuperAdmin) && isApprovedAndActive;

    if (isSuperAdmin) {
      if (
        practitionerInfo?.status === PRACTITIONER_STATUS.PENDING ||
        !practitionerInfo?.isActive
      ) {
        return (
          <FlexBox
            justifyContent="between"
            className="w-100"
            alignItems="center"
          >
            {(onReject || (!practitionerInfo?.isActive && isSuperAdmin)) && (
              <Button
                type="button"
                variant="danger"
                className="w-auto"
                onClick={onReject}
              >
                Reject
              </Button>
            )}
            {onApprove &&
              (practitionerInfo?.status === PRACTITIONER_STATUS.PENDING ? (
                <Button type="button" className="w-auto" onClick={onApprove}>
                  Approve
                </Button>
              ) : (
                <>
                <Button type="button" className="w-auto btn-danger" onClick={onDelete}>
                  Delete
                </Button>
                <Button type="button" className="w-auto" onClick={onClose}>
                  Close
                </Button>
                </>
              ))}
          </FlexBox>
        );
      } else if (canDisable) {
        return (
          <FlexBox
            justifyContent="between"
            className="w-100"
            alignItems="center"
          >
            <SimpleButton
              variant={
                practitionerDetails?.isDisabled
                  ? "outline-success"
                  : "outline-danger"
              }
              onClick={() => onDisable(!practitionerDetails?.isDisabled)}
            >
              {practitionerDetails?.isDisabled ? "Enable" : "Disable"}{" "}
              Practitioner
            </SimpleButton>

            <Button type="button" className="w-auto" onClick={onClose}>
              Close
            </Button>
          </FlexBox>
        );
      } else {
        return (
          <>
          <Button type="button" className="w-auto btn-danger" onClick={onClose}>
            Delete
          </Button>
          <Button type="button" className="w-auto" onClick={onClose}>
            Close
          </Button>
          </>
        );
      }
    } else if (practitionerInfo?.status === PRACTITIONER_STATUS.PENDING) {
      return (
        <FlexBox justifyContent="between" className="w-100" alignItems="center">
          {(onReject || (!practitionerInfo?.isActive && isSuperAdmin)) && (
            <>
            <Button type="button" className="w-auto btn-danger" onClick={onDelete}>
              Delete
            </Button>
            <Button
              type="button"
              variant="danger"
              className="w-auto"
              onClick={onReject}
            >
              Reject
            </Button>
            </>
          )}
          {onApprove &&
            (practitionerInfo?.status === PRACTITIONER_STATUS.PENDING ? (
              <Button type="button" className="w-auto" onClick={onApprove}>
                Approve
              </Button>
            ) : (
              <>
              <Button type="button" className="w-auto btn-danger" onClick={onDelete}>
                Delete
              </Button>
              <Button type="button" className="w-auto" onClick={onClose}>
                Close
              </Button>
              </>
            ))}
        </FlexBox>
      );
    } else if (canDisable) {
      return (
        <FlexBox justifyContent="between" className="w-100" alignItems="center">
          <SimpleButton
            variant={
              practitionerDetails?.isDisabled
                ? "outline-success"
                : "outline-danger"
            }
            onClick={() => onDisable(!practitionerDetails?.isDisabled)}
          >
            {practitionerDetails?.isDisabled ? "Enable" : "Disable"}{" "}
            Practitioner
          </SimpleButton>
          <Button type="button" className="w-auto btn-danger" onClick={onDelete}>
            Delete
          </Button>
          <Button type="button" className="w-auto" onClick={onClose}>
            Close
          </Button>
        </FlexBox>
      );
    } else if (practitionerInfo?.status === PRACTITIONER_STATUS.REJECTED) {
      return (
        <>
        <Button type="button" className="w-auto btn-danger" onClick={onDelete}>
          Delete
        </Button>
        <Button type="button" className="w-auto" onClick={onClose}>
          Reset
        </Button>
        </>
      );
    } else {
      return (
        <>
        <Button type="button" className="w-auto btn-danger" onClick={onDelete}>
          Delete
        </Button>
        <Button type="button" className="w-auto" onClick={onClose}>
          Close
        </Button>
        </>
      );
    }
  };

  return (
    <SimpleModal
      open={open}
      close={onClose}
      footer={getFooter()}
      title={`${
        practitionerInfo?.firstName + " " + practitionerInfo?.lastName
      }'s profile`}
    >
      <div
        className={`practitioner-info w-100 ${
          isScrollable ? "scrollable-content" : ""
        }`}
      >
        <PractitionerProfileCard
          isLoading={therapiesLoading || practitionerLoading}
          profilePicUrl={profilePicUrl}
          isEditable={false}
          practitionerDetails={practitionerDetails}
          onProfileUpdate={() => {}}
          therapies={therapies}
          practitionerTherapies={practitionerTherapies}
          practitionerSubscriptions={practitionerSubscriptions}
          //onTherapiesUpdate={handleTherapiesUpdate}
          //onTherapyDelete={handleTherapyDelete}
          //onProfilePicUpdate={handleProfilePicUpdate}
          practitionerDocuments={practitionerDocuments}
          //onCertificateUpdate={handlePractitionerDocumentsUpdate}
        />
        {/* <PractitionerProfileCard
          //isWrapInCard={false}
          //isShowAttachments={false}
          //isShowTab={false}
          practitionerDetails={practitionerInfo}
          //isAdminConfigRoute={true}
          onProfileUpdate={() => {}}
        /> */}
      </div>
    </SimpleModal>
  );
};

export default PractitionerInfo;
